var _path, _path2, _g, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3195 22H6.43349C3.98949 22 2.00049 20.011 2.00049 17.565V6.436C2.00049 3.99 3.98949 2 6.43349 2H11.3085C13.7545 2 15.7445 3.99 15.7445 6.436V7.368C15.7445 7.782 15.4085 8.118 14.9945 8.118C14.5805 8.118 14.2445 7.782 14.2445 7.368V6.436C14.2445 4.816 12.9275 3.5 11.3085 3.5H6.43349C4.81649 3.5 3.50049 4.816 3.50049 6.436V17.565C3.50049 19.184 4.81649 20.5 6.43349 20.5H11.3195C12.9315 20.5 14.2445 19.188 14.2445 17.576V16.633C14.2445 16.219 14.5805 15.883 14.9945 15.883C15.4085 15.883 15.7445 16.219 15.7445 16.633V17.576C15.7445 20.016 13.7585 22 11.3195 22Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1625",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 11,
    width: 15,
    height: 2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99609 11.25H22.537V12.75H8.99609V11.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1625)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7871 12.75H9.74609C9.33209 12.75 8.99609 12.414 8.99609 12C8.99609 11.586 9.33209 11.25 9.74609 11.25H21.7871C22.2011 11.25 22.5371 11.586 22.5371 12C22.5371 12.414 22.2011 12.75 21.7871 12.75Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_67_1625",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 8,
    width: 5,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1099 8.33521H22.5372V15.666H18.1099V8.33521Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_67_1625)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8596 15.666C18.6676 15.666 18.4746 15.593 18.3286 15.445C18.0366 15.151 18.0376 14.677 18.3306 14.385L20.7246 12L18.3306 9.61596C18.0376 9.32396 18.0356 8.84996 18.3286 8.55596C18.6206 8.26196 19.0946 8.26196 19.3886 8.55396L22.3166 11.469C22.4586 11.609 22.5376 11.801 22.5376 12C22.5376 12.199 22.4586 12.391 22.3166 12.531L19.3886 15.447C19.2426 15.593 19.0506 15.666 18.8596 15.666Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.8147aa208f419fdddcab9cdb06a15b80.svg";
export { ForwardRef as ReactComponent };